module.exports = __webpack_public_path__ + "img/cdn.22bd657e.png";